import HttpClient from '@/utility/http-client';

export default {
    getDeposit(page: number, rowPerPage: number, filters: any[], quickFilters: any[]) {
        const filter = filters && filters.length > 0 ? Buffer.from(JSON.stringify({ filter: filters })).toString('base64') : '';
        const quickFilter = quickFilters && quickFilters.length > 0 ? Buffer.from(JSON.stringify({ filter: quickFilters })).toString('base64') : '';
        const url = `/api/deposit/?page=${page}&rowsPerPage=${rowPerPage}&q=${quickFilter}&filter=${filter}`;
        return HttpClient.instance().get(url);
    },

    getDepositByID(id: any) {
        const url = `/api/deposit/${id}`;
        return HttpClient.instance().get(url);
    },

    createDeposit(dataRequest: any) {
        const url = `/api/deposit/`;
        return HttpClient.instance().put(url, dataRequest);
    },

    updateDeposit(id: any, dataRequest: any) {
        const url = `/api/deposit/${id}`;
        return HttpClient.instance().post(url, dataRequest);
    },

    checkTransaction(tranCode: any) {
        const url = `/api/order_transactions/check/?TransactionCode=${tranCode}`;
        return HttpClient.instance().get(url);
    },
    exportData(filters: any[], quickFilters: any[]) {
        const filter = filters && filters.length > 0 ? Buffer.from(JSON.stringify({ filter: filters })).toString('base64') : '';
        const quickFilter = quickFilters && quickFilters.length > 0 ? Buffer.from(JSON.stringify({ filter: quickFilters })).toString('base64') : '';
        const url = `/api/deposit/export/?filter=${filter}&page=${1}&rowsPerPage=${1000000}&q=${quickFilter}`;
        return HttpClient.instance('arraybuffer').get(url);
    },
}